import api from './api';

export type SPhoneAccountConfig = {
  userId: string;
  enabled: boolean;
  displayName?: string;
  extension?: string;
  username: string;
  password: string;
  allowInternalCalls?: boolean;
  allowExternalCalls?: boolean;
};

export type SPhoneMyConfig = {
  enabled: boolean;
  reason?: string;
  wsServer?: string;
  domain?: string;
  autoRegister?: boolean;
  defaultOutboundPrefix?: string;
  iceServers?: string[];
  account?: SPhoneAccountConfig | null;
};

export const sPhoneService = {
  async getMyConfig(): Promise<SPhoneMyConfig> {
    const response = await api.get('/sphone/me-config');
    return response.data?.data || { enabled: false, reason: 'Unavailable' };
  },
};
